export enum VeevaErrorCodes {
	InvalidVeevaUser = "VEEVA_RECORD_ERROR",
	PtEmailAlreadyExists = "PT_EMAIL_ALREADY_EXISTS",
}

export class InvalidVeevaUser extends Error {
	public constructor(message?: string) {
		super(message);
	}
}
